/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */

// To support react and browsers
import 'core-js/stable';

// Not sure why this is needed
// import 'regenerator-runtime/runtime';
